export abstract class MachiningGroupsEvent {}

export class MachiningGroupsLoad extends MachiningGroupsEvent {}
